import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { Opportunity } from "../opportunity/entity";
import { Skill } from "../skill";

import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import { doesExist } from "@shared/backend/entity-security/does-exist";
import { type OpportunitySkill } from "./entity";

export const OpportunitySkillEntityConfig: HyperEntityConfig<OpportunitySkill> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: Allow.authenticated,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      opportunity: {
        $is: await copyApiPrefilterPerRole(Opportunity),
      },
    });

    filter(Roles.All, {
      skill: {
        $is: await copyApiPrefilterPerRole(Skill),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, (entity) =>
      doesExist(Opportunity, {
        id: entity.opportunityId,
        organization: {
          $id: remult.user!.organizationId!,
        },
      }),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, {
      opportunity: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
  },

  id: {
    opportunityId: true,
    skillId: true,
  },
};
